import { Link } from 'react-router';
import { FileQuestion } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center space-y-4 max-w-md">
        <div className="w-16 h-16 rounded-2xl bg-base-content/5 flex items-center justify-center mx-auto">
          <FileQuestion size={32} className="text-base-content/30" />
        </div>
        <h1 className="text-2xl font-bold">Page not found</h1>
        <p className="text-base-content/50 text-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/dashboard" className="btn btn-primary btn-sm gap-2">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
